/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsConditionsModel } from '../../models/terms-conditions-model';

export interface TermsConditionsIdGet$Params {
  id: string;
}

export function termsConditionsIdGet(http: HttpClient, rootUrl: string, params: TermsConditionsIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<TermsConditionsModel>> {
  const rb = new RequestBuilder(rootUrl, termsConditionsIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<TermsConditionsModel>;
    })
  );
}

termsConditionsIdGet.PATH = '/TermsConditions/{id}';
